import api from '@/api'

export default {
    /**
     * 웹파트 페이지 목록을 조회합니다.
     * @returns 메뉴관리에서 추가한 웹파트 페이지 목록
     */
    get(comCode: string): Promise<webpartv3.WebpartPage[]> {
        return api.get({
            url: `/Webpart/WebpartPage/api/getlist?comCode=${comCode}`,
        })
    },
}
